import { gql } from '@apollo/client';
import { ChargerGroupForExtend } from './fragments';

export const listChargerGroupsForExtend = gql`
  query listChargerGroupsForExtend($input: ListChargerGroupsInput!) {
    listChargerGroups(input: $input) {
      edges {
        ...ChargerGroupForExtend
        chargers: chargersLoaded {
          edges {
            altId
          }
          total
        }
      }
      total
    }
  }
  ${ChargerGroupForExtend}
`;
